/* Native catalogue enhancement: all content and links work without JavaScript. */
(() => {
  if (customElements.get('guild-set-landing')) return;
  class GuildSetLanding extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const fine = matchMedia('(hover: hover) and (pointer: fine)');
      const button = this.querySelector('.motion-toggle');
      const cards = [...this.querySelectorAll('.product')];
      const count = this.querySelector('[data-set-count]');
      const suffix = count.dataset.countSuffix;
      let paused = false;
      try { paused = sessionStorage.getItem('guild-set-motion') === 'paused'; } catch {}
      let enabled = false;
      const items = [];
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        entry.target.classList.toggle('in-view', entry.isIntersecting);
        if (!entry.isIntersecting) items.find(item => item.card === entry.target)?.reset();
      }), { threshold: .08 });
      cards.forEach((card, i) => {
        const stage = card.querySelector('.stage');
        const object = card.querySelector('.product-object');
        if (!object) return;
        card.style.setProperty('--float-delay', `${-i * .83}s`);
        observer.observe(card);
        let raf = 0, active = false, tx = 0, ty = 0, x = 0, y = 0, glow = 0;
        const set = (key, value) => stage.style.setProperty(key, value);
        const paint = () => {
          raf = 0; x += (tx - x) * .13; y += (ty - y) * .13; glow += ((active ? 1 : 0) - glow) * .12;
          set('--tilt-x', `${(-y * 7).toFixed(3)}deg`); set('--tilt-y', `${(x * 11).toFixed(3)}deg`);
          set('--drift-x', `${(x * 5).toFixed(2)}px`); set('--lift', `${(-glow * 8).toFixed(2)}px`);
          set('--light-x', `${50 + x * 39}%`); set('--light-y', `${45 + y * 35}%`);
          set('--shine-position', `${50 - x * 35}%`); set('--shine-opacity', String(.1 + glow * .46)); set('--shadow-x', `${-x * 8}px`);
          if (Math.abs(tx - x) + Math.abs(ty - y) + Math.abs((active ? 1 : 0) - glow) > .003) raf = requestAnimationFrame(paint);
        };
        const queue = () => { if (!raf) raf = requestAnimationFrame(paint); };
        const leave = () => { active = false; tx = ty = 0; card.classList.remove('is-pointed'); queue(); };
        const reset = () => { cancelAnimationFrame(raf); raf = 0; active = false; tx = ty = x = y = glow = 0; stage.removeAttribute('style'); card.classList.remove('is-pointed'); };
        stage.addEventListener('pointermove', event => {
          if (!enabled || !fine.matches || event.pointerType === 'touch') return;
          const rect = stage.getBoundingClientRect();
          tx = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
          ty = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2));
          active = true; card.classList.add('is-pointed'); queue();
        }, { signal });
        for (const name of ['pointerleave', 'pointercancel']) stage.addEventListener(name, leave, { signal });
        items.push({ card, reset });
      });
      const motion = () => {
        enabled = !reduce.matches && !paused && !document.hidden;
        this.classList.toggle('motion-enabled', enabled); this.classList.toggle('motion-reduced', !enabled);
        button.hidden = false; button.textContent = reduce.matches ? button.dataset.reduced : paused ? button.dataset.off : button.dataset.on;
        button.setAttribute('aria-pressed', String(!reduce.matches && !paused)); button.disabled = reduce.matches;
        if (!enabled) items.forEach(item => item.reset());
      };
      button.addEventListener('click', () => { paused = !paused; try { sessionStorage.setItem('guild-set-motion', paused ? 'paused' : 'running'); } catch {} motion(); }, { signal });
      reduce.addEventListener('change', motion, { signal });
      fine.addEventListener('change', () => items.forEach(item => item.reset()), { signal });
      document.addEventListener('visibilitychange', motion, { signal });
      window.addEventListener('pagehide', () => items.forEach(item => item.reset()), { signal });
      window.addEventListener('pageshow', motion, { signal });
      const controls = this.querySelector('[data-format-controls]'); controls.hidden = false;
      const buttons = [...controls.querySelectorAll('[data-format-filter]')];
      buttons.forEach(filter => {
        if (filter.dataset.formatFilter !== 'all' && !cards.some(card => card.dataset.format === filter.dataset.formatFilter)) filter.hidden = true;
        filter.addEventListener('click', () => {
          buttons.forEach(b => b.setAttribute('aria-pressed', String(b === filter)));
          let visible = 0;
          cards.forEach(card => { card.hidden = filter.dataset.formatFilter !== 'all' && card.dataset.format !== filter.dataset.formatFilter; if (!card.hidden) visible++; });
          this.querySelectorAll('.set-group').forEach(group => {
            group.hidden = ![...group.querySelectorAll('.product')].some(card => !card.hidden);
            this.querySelector(`[data-set-link="${group.id}"]`).hidden = group.hidden;
          });
          count.textContent = (visible === 1 ? count.dataset.countOne : count.dataset.countTemplate).replace('__count__', String(visible)) + suffix;
          this.querySelector('.set-empty').hidden = visible !== 0;
          items.forEach(item => item.reset());
        }, { signal });
      });
      motion();
      this.cleanup = () => { observer.disconnect(); items.forEach(item => item.reset()); this.controller.abort(); };
    }
    disconnectedCallback() { this.cleanup?.(); }
  }
  customElements.define('guild-set-landing', GuildSetLanding);
})();
